import { DateTzPipe } from 'O3_core';
import { CommonModule } from "@angular/common";
import { Component, inject, OnInit, signal } from "@angular/core";
import { RouterModule } from "@angular/router";
import { firstValueFrom } from "rxjs";
import { BaseView, TranslatePipe } from "O3_core";
import { IJobExecution } from "../interfaces/job-execution.interface";
import { JobExecutionService } from "../services/job-execution.service";

@Component({
  selector: "o3-job-scheduler-execution-detail",
  imports: [CommonModule, TranslatePipe, DateTzPipe, RouterModule],
  templateUrl: "./detail.html",
  styleUrl: "./detail.css",
})
export class JobExecutionDetail extends BaseView implements OnInit {
  private readonly jobExecutionService = inject(JobExecutionService);

  execution = signal<IJobExecution | null>(null);
  isLoading = signal<boolean>(true);

  breadCrumbs: string[] = [
    "breadCrumbs.jobScheduler",
    "breadCrumbs.executions",
  ];

  protected breadCrumbItems = [
    {
      label: "",
      routerLink: "/job-scheduler",
    },
    {
      label: "",
      routerLink: "/job-scheduler/executions",
    },
  ];

  ngOnInit(): void {
    this.setBreadCrumbs();
    const id = this.activatedRoute.snapshot.paramMap.get("id");
    if (id) {
      this.loadExecution(id);
    }
  }

  private setBreadCrumbs(): void {
    this.breadCrumbItems = [
      {
        label: this.i18n.t(this.breadCrumbs[0], { ns: this.viewKey() }),
        routerLink: "/job-scheduler",
      },
      {
        label: this.i18n.t(this.breadCrumbs[1], { ns: this.viewKey() }),
        routerLink: "/job-scheduler/executions",
      },
    ];
  }

  private async loadExecution(id: string): Promise<void> {
    this.isLoading.set(true);
    try {
      const data = await firstValueFrom(this.jobExecutionService.getById(id));
      this.execution.set(data);
    } catch (error) {
      this.processError(error);
    } finally {
      this.isLoading.set(false);
    }
  }

  goBack(): void {
    this.router.navigate(["/job-scheduler/executions"]);
  }

  formatJson(value: Record<string, unknown> | null | undefined): string {
    if (!value) return "";
    try {
      return JSON.stringify(value, null, 2);
    } catch {
      return String(value);
    }
  }

  formatDuration(ms: string | number | null | undefined): string {
    if (ms == null) return "—";
    const msNum = typeof ms === "string" ? parseInt(ms, 10) : ms;
    if (isNaN(msNum)) return "—";
    ms = msNum;
    if (ms < 1000) return `${ms} ms`;
    if (ms < 60000) return `${(ms / 1000).toFixed(2)} s`;
    const minutes = Math.floor(ms / 60000);
    const seconds = ((ms % 60000) / 1000).toFixed(0);
    return `${minutes}m ${seconds}s`;
  }
}
